import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const rejectDiscountRequest = createAsyncThunk(
	"discountApproval/reject",
	async ({ requestId, rejected_items, general_comments }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.post(`discount-request/approval/${requestId}/reject`, {
				rejected_items,
				general_comments,
			});
			return response.data?.data ?? response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data?.message || "Failed to reject discount request");
		}
	}
);

const DiscountApprovalRejectSlice = createSlice({
	name: "DiscountApprovalRejectSlice",
	initialState: {
		isLoading: false,
		success: false,
		error: null,
		data: null,
	},
	reducers: {
		resetRejectState: (state) => {
			state.isLoading = false;
			state.success = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(rejectDiscountRequest.pending, (state) => {
			state.isLoading = true;
			state.success = false;
			state.error = null;
		});
		builder.addCase(rejectDiscountRequest.fulfilled, (state, action) => {
			state.isLoading = false;
			state.success = true;
			state.data = action.payload;
		});
		builder.addCase(rejectDiscountRequest.rejected, (state, action) => {
			state.isLoading = false;
			state.success = false;
			state.error = action.payload || action.error.message || "Unknown error";
		});
	},
});

export const { resetRejectState } = DiscountApprovalRejectSlice.actions;
export default DiscountApprovalRejectSlice.reducer;
